import { API_ENDPOINTS } from "@utils/api/endpoints";
import { useSearchStore } from '@stores/search';

export default async function (params, body) {
  const search = useSearchStore();

  if (search.newsLoaded) {
    return { status: ref('success') };
  }

  search.setNewsLoaded(false);

  const { data, error, status } = await useApiFetch(API_ENDPOINTS.CONTENT_POST, {
    method: 'POST',
    params,
    body
  });

  if (status.value === 'error') {
    sentryCaptureEvent({
      message: 'load-content-news',
      level: 'error',
      extra: { error: error.value }
    });
  } else {
    search.setNews(data.value);
  }

  search.setNewsLoaded(true);
  return { data, error, status };
}
